import React,{ useEffect, useState } from 'react';
import { queuedApiFetch } from '../api';

function RVWS_account_dashboard() {
    const [powerBiUrl, setPowerBiUrl] = useState('');
    const url_name='RVWS_Account_Dashboard';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const requestOptions = { method: 'GET' };
                const data = await queuedApiFetch(
                    `/project/get_powerbi_url?url_name=${url_name}`,
                    requestOptions
                );

                if (
                    data?.apistatus?.Status_Code === 200 &&
                    data?.apistatus?.Status_Description?.toLowerCase() === 'success'
                ) {
                    const acc_rvw_dash_url=`${data.data}&filterPaneEnabled=false&navContentPaneEnabled=false`;
                    setPowerBiUrl(acc_rvw_dash_url);
                    //setPowerBiUrl(data.data); 
                } else {
                    console.error('Failed to load Power BI URL');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } 
        };

        fetchData();
    }, []);


    return (

        <iframe title="Power BI Report" src={powerBiUrl} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>

    );
}

export default RVWS_account_dashboard;

// function RVWS_account_dashboard() {
 
//  const powerBiUrl = process.env.REACT_APP_RVWS_Account_Dashboard;
//  //console.log("RVWS Account Dashboard",powerBiUrl)

         
  
//   return (
    
//     //   <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>
//     <iframe title="Account-RVWS Dashboard" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=56e26ff9-e0b5-48d8-816a-4ca595005fb8&autoAuth=true&cti… &filterPaneEnabled=false&navContentPaneEnabled=false" frameborder="0" allowFullScreen="true" sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin"> </iframe>
    
//   );
// }

// export default RVWS_account_dashboard;





// import React, { useEffect, useRef, useState } from "react";
// import * as powerbi from "powerbi-client";
// import { queuedApiFetch } from "../api";

// const RVWS_account_dashboard = () => {
//   const reportContainerRef = useRef(null);
//   const [embedConfig, setEmbedConfig] = useState(null);

//   useEffect(() => {
//     const fetchEmbedInfo = async () => {
//       try {
//         const response = await queuedApiFetch(`/project/get_account_powerbi_details`, { method: "GET" });

//         if (
//           response?.apistatus?.Status_Code === 200 &&
//           response?.apistatus?.Status_Description?.toLowerCase() === "success" &&
//           response?.data?.embed_url &&
//           response?.data?.access_token &&
//           response?.data?.report_id
//         ) {
//           setEmbedConfig({
//             type: "report",
//             id: response.data.report_id,
//             embedUrl: response.data.embed_url,
//             accessToken: response.data.access_token,
//             tokenType: powerbi.models.TokenType.Embed,
//             permissions: powerbi.models.Permissions.All,
//             settings: {
//               filterPaneEnabled: false,
//               navContentPaneEnabled: false,
//             },
//           });
//         } else {
//           console.error("Invalid Power BI embed response", response);
//         }
//       } catch (err) {
//         console.error("Error fetching embed info:", err);
//       }
//     };

//     fetchEmbedInfo();
//   }, []);

//   useEffect(() => {
//     if (!embedConfig || !reportContainerRef.current) return;

//     const powerbiService = new powerbi.service.Service(
//       powerbi.factories.hpmFactory,
//       powerbi.factories.wpmpFactory,
//       powerbi.factories.routerFactory
//     );

//     // Try-catch around reset to avoid “powerBiEmbed null” error
//     try {
//       if (reportContainerRef.current) {
//         powerbiService.reset(reportContainerRef.current);
//       }
//     } catch (err) {
//       console.warn("Power BI reset skipped (container not ready):", err);
//     }

//     const report = powerbiService.embed(reportContainerRef.current, embedConfig);

//     report.on("loaded", () => console.log("Power BI Report loaded"));
//     report.on("error", (event) => console.error("Embed error:", event.detail));

//     // Cleanup safely
//     return () => {
//       try {
//         if (reportContainerRef.current) {
//           powerbiService.reset(reportContainerRef.current);
//           console.log("Cleaned up Power BI report safely");
//         }
//       } catch (err) {
//         console.warn("Cleanup skipped — container already removed:", err);
//       }
//     };
//   }, [embedConfig]);

//   return (
//     <div
//       ref={reportContainerRef}
//       style={{ height: "90vh", width: "100%", border: "1px solid #ccc" }}
//     />
//   );
// };

// export default RVWS_account_dashboard;